import { DocumentServicesObject } from '@wix/document-services-types';
import { noop } from 'lodash';
import { PlatformApiMethods } from '../../../types/platformApi';
import { IExperimentsApiAdapter } from '../../utils/experimentsApiAdapter';
import { IntentInstallServices } from './IntentInstallServices';

let resolveIntentInstallServices: (value: IntentInstallServices) => void;

const intentInstallServicesPromise = new Promise<IntentInstallServices>(
  (resolve) => {
    resolveIntentInstallServices = resolve;
  },
);

export async function getIntentInstallServices() {
  return intentInstallServicesPromise;
}

export function initIntentInstallServices(
  platformApiMethods: PlatformApiMethods,
  documentServicesAPI: DocumentServicesObject,
  experimentsAPI: IExperimentsApiAdapter,
) {
  const intentInstallServices = new IntentInstallServices(
    platformApiMethods,
    documentServicesAPI,
    experimentsAPI,
  );
  resolveIntentInstallServices(intentInstallServices);
  return intentInstallServices;
}

export const createIntentInstallAsyncHandlers = () => {
  let isIntentInstallStarting = false;

  const setIsIntentInstallStarting = (value: boolean) => {
    isIntentInstallStarting = value;
  };

  const getIsIntentInstallStarting = () => isIntentInstallStarting;

  let intentInstallLaunched: () => void = noop;

  const intentInstallPromise = new Promise<void>((resolve) => {
    intentInstallLaunched = resolve;
  });

  const waitForIntentInstallToStart = async () => intentInstallPromise;

  return {
    setIsIntentInstallStarting,
    getIsIntentInstallStarting,
    waitForIntentInstallToStart,
    intentInstallLaunched,
  };
};
